/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ElementRef,
  ChangeDetectorRef,
  Renderer2,
  NgZone
} from '@angular/core';

import { ChangedEvent, TextService, ResourceService } from '@typescript-kit/core';
import { ImageModel, ImageFieldKey, ComponentFieldKey, ViewComponentKey } from '@typescript-kit/view';

import { BaseDirective } from '../../directive/base.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'img[kitModel]',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent extends BaseDirective<ImageModel> {
  private _source: string;

  constructor(
    changeDetector: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone,
    textService: TextService,
    private readonly resourceService: ResourceService
  ) {
    super(changeDetector, elementRef, renderer, ngZone, textService);
  }

  get hostClass(): string {
    return 'kit-image';
  }

  get source(): string {
    return this._source;
  }

  protected onModelChanged(model: ImageModel) {
    super.onModelChanged(model);
    this.refreshSource();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes[ImageFieldKey.SOURCE]) {
      this.refreshSource();
    }
  }

  private refreshSource() {
    const source = this.resourceService.getResource(this.model.source) || this.model.source;
    if (source === this._source) {
      return;
    }
    this._source = source;
    this.setAttribute('src', source, '');
  }

}
